import React from "react"

export const columnConfig = ({
  deleteManager,
  setSelectedManager,
  setIsUpdateModalOpen,
  handleReport,
  isReportLoading,
}) => [
  {
    accessor: "id",
    title: "Id",
    sortable: true,
  },
  {
    accessor: "update",
    title: "Güncelle",
    sortable: true,
    render: (record) => (
      <div className="flex items-center justify-end gap-2">
        <button
          className="text-blue-500 font-bold hover:text-blue-700"
          onClick={() => {
            setSelectedManager(record)
            setIsUpdateModalOpen(true)
          }}
        >
          Güncelle
        </button>
      </div>
    ),
  },
  {
    accessor: "report",
    title: "Rapor",
    sortable: true,
    render: (record) => (
      <div className="flex items-center justify-end gap-2">
        {isReportLoading ? (
          <div className="animate-spin rounded-full h-5 w-5 border-t-4 border-pink-600"></div>
        ) : (
          <button
            className="text-blue-500 font-bold hover:text-blue-700"
            onClick={() => {
              handleReport(record._id)
            }}
          >
            Rapor İndir
          </button>
        )}
      </div>
    ),
  },
  {
    accessor: "companyNames",
    title: "Şirket Adı",
    sortable: true,
    render: (record) => record.companyNames[0] || "",
  },
  {
    accessor: "createdAt",
    title: "Oluşturulma Tarihi",
    sortable: true,
    render: (record) => (record.createdAt ? new Date(record.createdAt).toLocaleDateString() : ""),
  },
  {
    accessor: "isActive",
    title: "Aktiflik",
    sortable: true,
    render: (record) => (record.isActive ? "Aktif" : "Pasif"),
  },
  {
    accessor: "isCompleted",
    title: "Tamamlanmışlık",
    sortable: true,
    render: (record) => (record.isCompleted ? "Tamamlandı" : "Tamamlanmadı"),
  },
  {
    accessor: "date_range",
    title: "Tarih Aralığı",
    sortable: true,
    render: (record) =>
      record.date_range.start && record.date_range.end
        ? `${new Date(record.date_range.start).toLocaleDateString()} - ${new Date(
            record.date_range.end,
          ).toLocaleDateString()}`
        : "Tarih Aralığı Belirtilmemiş",
  },
  {
    accessor: "instagram-tags",
    title: "Instagram Tags",
    sortable: true,
    render: (record) =>
      record.instagram && record.instagram.tags?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.instagram.tags.map((tag, index) => (
            <span
              key={`instagram-tag-${record._id}-${index}-${tag.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                tag.state === "done"
                  ? "bg-green-100 text-green-800"
                  : tag.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {tag.keyword || `Tag ${index + 1}`} - {tag.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "instagram-hashtags",
    title: "Instagram Hashtags",
    sortable: true,
    render: (record) =>
      record.instagram && record.instagram.hashtags?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.instagram.hashtags.map((hashtag, index) => (
            <span
              key={`instagram-hashtag-${record._id}-${index}-${hashtag.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                hashtag.state === "done"
                  ? "bg-green-100 text-green-800"
                  : hashtag.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {hashtag.keyword || `Tag ${index + 1}`} - {hashtag.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "tiktok",
    title: "TikTok",
    sortable: true,
    render: (record) =>
      record.tiktok && record.tiktok.search?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.tiktok.search.map((search, index) => (
            <span
              key={`tiktok-search-${record._id}-${index}-${search.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                search.state === "done"
                  ? "bg-green-100 text-green-800"
                  : search.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {search.keyword || `Tag ${index + 1}`} - {search.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "linkedIn",
    title: "LinkedIn",
    sortable: true,
    render: (record) =>
      record.linkedIn && record.linkedIn.search?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.linkedIn.search.map((search, index) => (
            <span
              key={`linkedin-search-${record._id}-${index}-${search.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                search.state === "done"
                  ? "bg-green-100 text-green-800"
                  : search.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {search.keyword || `Tag ${index + 1}`} - {search.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "twitter",
    title: "Twitter",
    sortable: true,
    render: (record) =>
      record.twitter && record.twitter.search?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.twitter.search.map((search, index) => (
            <span
              key={`twitter-search-${record._id}-${index}-${search.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                search.state === "done"
                  ? "bg-green-100 text-green-800"
                  : search.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {search.keyword || `Tag ${index + 1}`} - {search.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "youtube",
    title: "YouTube",
    sortable: true,
    render: (record) =>
      record.youtube && record.youtube.search?.length > 0 ? (
        <div className="flex flex-wrap gap-1">
          {record.youtube.search.map((search, index) => (
            <span
              key={`youtube-search-${record._id}-${index}-${search.keyword || index}`}
              className={`px-2 py-1 text-xs rounded-full ${
                search.state === "done"
                  ? "bg-green-100 text-green-800"
                  : search.state === "pending"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {search.keyword || `Tag ${index + 1}`} - {search.state}
            </span>
          ))}
        </div>
      ) : (
        "Pasif"
      ),
  },
  {
    accessor: "actions",
    title: "Sil",
    sortable: true,
    render: (record) => (
      <div className="flex items-center justify-end gap-2">
        <button
          className="text-red-500 font-bold hover:text-red-700"
          onClick={() => deleteManager(record._id)}
        >
          Sil
        </button>
      </div>
    ),
  },
]
